// @module Eureka.MaxaPriceMatch.MaxaRequestReturn.View
define('Eureka.MaxaPriceMatch.MaxaCustomerEnquiry.View'
    , [
        'eureka_maxapricematch_maxacustomerenquiry.tpl'

        , 'Eureka.MaxaPriceMatch.MaxaPriceMatch.SS2Model'
        , 'Profile.Model'

        , 'Backbone'
    ]
    , function (
        eureka_maxapricematch_maxacustomerenquiry_tpl
        , MaxaPriceMatchSS2Model
        , ProfileModel
        , Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPriceMatch.MaxaPriceMatch.View @extends Backbone.View
        return Backbone.View.extend({

            template: eureka_maxapricematch_maxacustomerenquiry_tpl

            , initialize: function (options) {
                // this.profile = ProfileModel.getInstance()
                // console.log("this.profile", this.profile)
                // this.isLoggedIn = this.profile.attributes.isLoggedIn
                // console.log("this.isLoggedIn", this.isLoggedIn)
                // this.selectedFiles = [];
            }

            , events: {
                // 'click [data-action="submitButton"]': 'submitForm'
            }

            , bindings: {}

            , childViews: {}

            , getBreadcrumbPages: function getBreadcrumbPages() {
                return [{
                        text: 'Contact-Us',
                        href: '/'
                    }];
            }

            , validationSchema: {
                email: function (value) {
                    // Email validation (basic RFC 5322 compliant)
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                },
                firstname: function (value) {
                    // Allow typical name chars: letters, spaces, apostrophes, hyphens
                    return /^[a-zA-Z\s.'-]{2,50}$/.test(value);
                },
                lastname: function (value) {
                    // Allow typical name chars: letters, spaces, apostrophes, hyphens
                    return /^[a-zA-Z\s.'-]{2,50}$/.test(value);
                },
                phone: function (value) {
                    // Allow international and local formats (+, spaces, (), -, digits)
                    return /^\+?[0-9\s().-]{7,20}$/.test(value);
                },
                companyname: function (value) {
                    // Allow letters, numbers, spaces, ampersands, and punctuation
                    return /^[a-zA-Z0-9\s&.,'-]{2,100}$/.test(value);
                },
                enquiry: function (value) {
                    // Allow free text but not special characters that could break things
                    return /^[a-zA-Z0-9\s.,!?'"-]{5,500}$/.test(value);
                }
            }

            , errorList: {
                "firstname": { error: 'nameFirstError', input: 'enquiryFirstName' },
                "lastname": { error: 'nameLastError', input: 'enquiryLastName' },
                "phone": { error: 'phoneError', input: 'enquiryPhone' },
                "email": { error: 'emailError', input: 'enquiryEmail' },
                "companyname": { error: 'companynameError', input: 'enquiryCName' },
                "enquiry": { error: 'enquiryError', input: 'enquiryDetails' },
            }

            , submitForm: function submitForm() {


                // Object.entries(this.errorList).forEach(([key, value]) => {
                //     let element = document.getElementById(value.error)
                //     console.log({ element: element, value: value, key: key, list: this.errorList })
                //     element.style.display = 'none'
                //     let input = document.getElementById(value.input)
                //     input.style.border = "2px solid black"
                // });


                // let model = new MaxaPriceMatchSS2Model();
                // let data = {
                //     isEnquiry: true,
                //     firstname: document.getElementById('enquiryFirstName').value,
                //     lastname: document.getElementById('enquiryLastName').value,
                //     phone: document.getElementById('enquiryPhone').value,
                //     email: document.getElementById('enquiryEmail').value,
                //     companyname: document.getElementById('enquiryCName').value,
                //     enquiry: document.getElementById('enquiryDetails').value,
                //     isSanbox: window.location.href.includes('sandbox')
                // }
                // let isValid = this.validate(data, this.validationSchema)
                // if (isValid.length === 0) {
                //     model.fetch({ type: "post", data: data }).done(function (result) {
                //         if (result.success) {
                //             window.location = "https://" + SC.ENVIRONMENT.shoppingDomain
                //         }
                //     });
                // } else {
                //     console.log({ isValid })
                //     for (let i = 0; i < isValid.length; i++) {
                //         console.log(this.errorList[isValid[i].message].error)
                //         let element = document.getElementById(this.errorList[isValid[i].message].error)
                //         element.style.display = "block"
                //         let input = document.getElementById(this.errorList[isValid[i].message].input)
                //         input.style.border = "2px solid red"
                //     }

                // }
            }

            , validate: function (data, schema) {
                // return Object.keys(schema).map(function (property) {
                //     var validator = schema[property];

                //     return [property, !validator.required || (property in data), validator(data[property])];
                // }).filter(function (entry) {
                //     return !entry[1] || !entry[2];
                // }).map(function (entry) {
                //     if (!entry[1]) return new Error(entry[0]);
                //     else return new Error(entry[0]);
                // });
            }

            //@method getContext @return Eureka.MaxaPriceMatch.MaxaPriceMatch.View.Context
            , getContext: function getContext() {
                //@class Eureka.MaxaPriceMatch.MaxaPriceMatch.View.Context
                this.message = this.message || 'Hello World!!'
                return {
                    message: this.message
                };
            }
        });
    });
